// A single field value sent to a provider as part of a provider setting mapping
export interface ProviderSettingFieldType {
    key: string;
    type: string; // trilean | enum | text | fee | measurement | string | int | decimal
    value: any;
}

// Maps one of our amenities to a provider's (vrbo, airbnb, etc) own amenity API
export interface ProviderSettingType {
    provider: string;
    level: 'property' | 'unit' | '';
    key: string;
    available: boolean;
    values?: {
        fields?: ProviderSettingFieldType[];
    };
}

export interface AmenityType {
    _id?: string;
    slug: string;
    title: string;
    description: string;
    image: string;
    icon: string;
    tags: string[];
    type: string;
    basePrice?: number;
    baseQuantity?: number;
    isActive: boolean;
    featured: boolean;
    providerSettings?: ProviderSettingType[];
    createdAt?: Date;
    updatedAt?: Date;
}

// Providers currently supported for amenity mapping
export const PROVIDER_OPTIONS: { value: string, text: string }[] = [
    { value: 'vrbo', text: 'Vrbo' },
    { value: 'custom', text: 'Custom' },
]

// Level at which a provider expects an amenity to be assigned
export const PROVIDER_SETTING_LEVEL_OPTIONS: { value: string, text: string }[] = [
    { value: 'property', text: 'Property' },
    { value: 'unit', text: 'Unit' },
]

// Shared list of known amenity tags, used for form entry, filtering, and grouping
export const AMENITY_TAG_OPTIONS: { tag: string, text: string }[] = [
    { tag: 'appliance', text: 'Appliance' },
    { tag: 'baby', text: 'Baby' },
    { tag: 'climate', text: 'Climate' },
    { tag: 'hygiene', text: 'Hygiene' },
    { tag: 'internet', text: 'Internet' },
    { tag: 'laundry', text: 'Laundry' },
    { tag: 'linens', text: 'Linens' },
    { tag: 'parking', text: 'Parking' },
    { tag: 'supplies', text: 'Supplies' },
    { tag: 'has-kitchen', text: 'Has Kitchen' },
    { tag: 'kitchen', text: 'Kitchen' },
    { tag: 'dining', text: 'Dining' },
    { tag: 'entertainment', text: 'Entertainment' },
    { tag: 'elevator', text: 'Elevator' },
    { tag: 'pool', text: 'Pool' },
    { tag: 'hot-tub', text: 'Hot Tub' },
    { tag: 'outdoor', text: 'Outdoor' },
]
